<template>
  <div style="width:100%;float:left;">
  </div>
</template>
<script>
var methods = {}

export default {
  // ===Component name
  name: "blank",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{

      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {

  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
